import withStyles from '@material-ui/core/styles/withStyles';
import { IStore, AppDispatch } from '../store';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { DriverStateDTO } from '../api/model';
import { WithStyles, Paper, Grid, Typography } from "@material-ui/core";
import { WithActions, toMap } from '../utils/utils';
import { DriverActions } from '../store/driver';
import { connect } from 'react-redux';
import StoreModel, { LoadedSingleResource } from '../store/StoreModel';
import { bindActionCreators } from 'redux';
import { ConfigData } from '../config';
import SimpleMapComponent from '../components/SimpleMapComponent';
import { Marker } from 'react-google-maps';
import { TwoColumnsGrid, TwoColumnsGridData } from '../components/TwoColumnsGrid';
import { Link } from 'react-router-dom';
import { IconButton } from '@material-ui/core/';
import TrackIcon from '@material-ui/icons/TrackChanges';
import { formatDistance } from 'date-fns/esm';
import { es } from 'date-fns/locale';

const styles = {
    root: {
        flexGrow: 1,
    },
};

interface DriverTraceMapDotsProps {
    id: number;
    data: LoadedSingleResource<DriverStateDTO>
}

const DriverTraceMapDots = (props: DriverTraceMapDotsProps) => {
    if (StoreModel.isLoaded(props.data)) {
        return <div>
            <Marker position={props.data.data!}></Marker>
        </div>
    } else {
        return <div>Cargando posición...</div>

    }
}


const DriverTraceMapDotsConnected = connect((state: IStore, ownProps: any) => ({
    data: state.driver.locationById[ownProps.id]
}))(DriverTraceMapDots);



interface DriverPageProps extends
    RouteComponentProps<{ id: number }>,
    WithStyles<keyof typeof styles>,
    WithActions<DriverActions> {


    driverActions: DriverActions;
    config: ConfigData;
    driverState: LoadedSingleResource<DriverStateDTO>;
}

interface DriverPageState {
    loaded: boolean;
}

const fd = (date: number | null | undefined, def: string) => {
    if (!date) {
        return def;
    }
    return `${new Date(date).toLocaleString()} (${formatDistance(date, new Date(), { locale: es })})`;
}

const DriverStatePanel = (props: { data: LoadedSingleResource<DriverStateDTO> }) => {
    if (!StoreModel.isLoaded(props.data)) {
        return <div>Cargando ...</div>
    };

    const data = props.data.data!;
    const columns: TwoColumnsGridData[] = [
        { type: 'title', label: `Usuario: ${data.name} ` },
        { type: 'divider' },
        { label: 'Estado', value: data.raceId ? 'Ocupado' : 'Libre' },
        { label: 'Ultima acción', value: fd(data.lastAction, 'Sin acción registrada') },
        { label: 'Ultima ubicación', value: fd(data.locationDate, 'Sin ubicación registrada') },
        { label: 'Cantidad de carreras', value: data.raceCount },
    ];

    if (data.raceId) {
        columns.push({
            label: 'Ir a carrera',
            renderValue: () => (
                <Link to={"/race/" + data.raceId}>
                    <IconButton aria-label='Seguir' >
                        <TrackIcon />
                    </IconButton>
                </Link>
            )
        })
    }

    return <TwoColumnsGrid data={columns} />
}

const DriverStatePanelConnected = connect((state: IStore, ownProps: any) => ({
    data: state.driver.locationById[ownProps.id]
}))(DriverStatePanel);

class DriverPage extends React.Component<DriverPageProps, DriverPageState> {

    static getDerivedStateFromProps(nextProps: DriverPageProps, prevState: DriverPageState) {
        if (prevState.loaded) {
            return prevState;
        }
        if (StoreModel.isLoaded(nextProps.driverState)) {
            return {
                loaded: true
            }
        }
        return prevState;
    }

    trace?: NodeJS.Timer;

    constructor(props: DriverPageProps) {
        super(props);
        this.state = {
            loaded: false
        }
    }

    shouldComponentUpdate(nextProps: DriverPageProps, nextState: DriverPageState) {
        if (this.state.loaded) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.props.actions.fetchLocationById(this.props.match.params.id);
        this.trace = setInterval(() => {
            this.props.actions.fetchLocationById(this.props.match.params.id);
        }, 1000 * 10);
    }

    componentWillUnmount() {
        if (this.trace) {
            clearInterval(this.trace);
        }
    }

    render() {

        const { classes, driverState, config } = this.props;

        if (StoreModel.isLoading(driverState)) {
            return <Grid container className={classes.root} spacing={16}>
                <Grid item xs={12}>
                    <Paper elevation={11} style={{ padding: 40, textAlign: 'center' }}>
                        <Typography variant="title">Cargando...</Typography>
                    </Paper>
                </Grid>
            </Grid>
        }
        if (StoreModel.isError(driverState)) {
            return (
                <Grid container className={classes.root} spacing={16}>
                    <Grid item xs={12}>
                        <Paper elevation={11} style={{ padding: 40, textAlign: 'center' }}>
                            <Typography variant="display2" style={{ paddingBottom: 20 }}>:(</Typography>
                            <Typography variant="title">Conductor no encontrado</Typography>
                        </Paper>
                    </Grid>
                </Grid>
            )
        }

        const state = driverState.data!;

        return <Grid container className={classes.root} spacing={16}>

            {state && (
                <>
                    <Grid item xs={12} xl={6}>
                        <Paper elevation={11} style={{ padding: 10 }}>
                            <Typography variant="display1">Posicion</Typography>
                            <SimpleMapComponent
                                zoom={16}
                                config={config}
                                handleRef={map => {
                                    map.panTo(state);
                                    (window as any).map = map;
                                }}
                            >
                                <DriverTraceMapDotsConnected id={state.id} />
                            </SimpleMapComponent>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} xl={6}>
                        <Paper elevation={11} style={{ padding: 10 }}>
                            <DriverStatePanelConnected id={state.id} />
                        </Paper>
                    </Grid>
                </>
            ) || <Grid item xs={12} xl={6}>
            <Paper elevation={11} style={{ padding: 10 }}>
                <Typography variant="display1">Seguimiento no disponible</Typography>
            </Paper>
        </Grid>
            }

        </Grid>
    }
};


const mapStateToProps = (state: IStore, ownProps: DriverPageProps) => ({
    ...ownProps,
    driverState: state.driver.locationById[ownProps.match.params.id],
    config: state.config.data
});


const styled = withStyles(styles as any)(DriverPage);
const connected = connect(mapStateToProps, (dispatch: AppDispatch) => ({
    actions: bindActionCreators(toMap(DriverActions), dispatch),
    driverActions: bindActionCreators(toMap(DriverActions), dispatch),
}))(styled as any);

export default connected as React.ComponentClass<Partial<DriverPageProps>>;




// WEBPACK FOOTER //
// ./src/pages/DriverPage.tsx